<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import axios from 'axios'
import { faArrowLeft } from '@fortawesome/duotone-regular-svg-icons'
import { setTitle } from '~/utils/dom'
import animation from '~/assets/lottie/404_Ufo_2.json'
import Button from '~/components/ui/Button.vue'

const {
  error,
  returnPath = '/'
} = defineProps<{
  error?: Error | null
  returnPath?: string
}>()

const { t } = useI18n()

setTitle(t('notFound.title'))

const code = computed(() => axios.isAxiosError(error) ? (error.status ?? 404) : 404)
</script>

<template>
  <div class="mx-0 flex max-w-full flex-col items-center justify-between gap-4 sm:mx-auto sm:max-w-screen-md md:flex-row">
    <div class="space-y-6 text-gray-50">
      <h1
        class="text-6xl font-bold sm:text-7xl"
        v-text="t('notFound.heading')"
      />
      <p class="text-base sm:text-lg">
        {{ t('notFound.message') }}
      </p>
      <p v-text="t('notFound.statusCode', { code })" />
      <Button
        :to="returnPath"
        size="xl"
      >
        <font-awesome-icon :icon="faArrowLeft" />
        {{ t('notFound.buttonText') }}
      </Button>
    </div>
    <LottieAnimation
      :animation-data="animation"
      class="w-full sm:w-[480px]"
    />
  </div>
</template>
